import { IconButton, Stack, Tooltip, Typography } from '@mui/material';

import { MaterialIcon } from '@common/ui/MaterialIcon/MaterialIcon';

import { Duration } from '@common/utils/datetime';
import { useMemo, useState } from 'react';
import { useInterval } from 'usehooks-ts';

export default function RequestTitle({
  requestId,
  dataUpdatedAt,
  isFetching,
  onFetch,
}: {
  requestId: string;
  dataUpdatedAt?: number;
  isFetching?: boolean;
  onFetch?: () => void;
}) {
  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={2}>
      <Typography variant="subtitle1">
        Access Request{' '}
        <Typography variant="inherit" color="primary.main" component="span">
          {requestId}
        </Typography>
      </Typography>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={0.5}>
        {onFetch && (
          <Tooltip title="Refresh">
            <IconButton onClick={() => onFetch()}>
              <MaterialIcon symbol="refresh" spin={isFetching} />
            </IconButton>
          </Tooltip>
        )}
        {dataUpdatedAt && dataUpdatedAt > 0 ? <RequestTitleUpdated dataUpdatedAt={dataUpdatedAt} /> : null}
      </Stack>
    </Stack>
  );
}

function RequestTitleUpdated({ dataUpdatedAt }: { dataUpdatedAt: number }) {
  const [now, setNow] = useState(Date.now());
  useInterval(() => setNow(Date.now()), 1000);

  const updated = useMemo(() => Duration.fromSeconds(dataUpdatedAt - now).readable, [dataUpdatedAt, now]);

  return (
    <Typography variant="tooltip" color="text.muted">
      Updated {updated} ago
    </Typography>
  );
}
